// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as Network$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/Network.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as BulkUploadRepoConfig from "./BulkUploadRepoConfig.bs.js";
import * as PartnerWalletRequestEncoder from "../../../../partner-dashboard/app/wallet/repo/request-encoders/PartnerWalletRequestEncoder.bs.js";

function bulkUpload(request, country) {
  var url = $$String.concat("", {
        hd: Config.Env.getHostName(undefined),
        tl: {
          hd: "/administrators/transactions/bulk_upload",
          tl: /* [] */0
        }
      });
  var encodedPayload = JSON.stringify(PartnerWalletRequestEncoder.BulkUploadRequestEncoder.execute(request));
  return Network$Catalyst.postRequestV2(url, encodedPayload, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(BulkUploadRepoConfig.BulkUploadWalletTransactionsResponseConverter.execute, result);
                        });
            });
}

function fetchBulkReasons(country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/transaction_reasons";
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(BulkUploadRepoConfig.BulkReasonResponseConverter.execute, result);
                        });
            });
}

var BulkUploadRepo = {
  bulkUpload: bulkUpload,
  fetchBulkReasons: fetchBulkReasons
};

export {
  BulkUploadRepo ,
  
}
/* Config Not a pure module */
